import { render } from "./Register.vue?vue&type=template&id=fea886c0&ts=true"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"

import "./Register.vue?vue&type=style&index=0&id=fea886c0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__